export default () => ({
    show: new URLSearchParams(location.search).get('drawer') || false,
    loading: false,
    checkout: false,
    updateCart(){
        this.loading = true;

        // send fetch reqeust to update cart
        fetch('/?view=cart')
        .then(response => response.text())
        .then(cartData => {
            this.$refs.cart_content.innerHTML = cartData;

            // This code is use to parse json object. for cart count
            var el = document.createElement('div');
            el.innerHTML = cartData;
            var cartCount = JSON.parse(el.querySelector('[data-options]').innerHTML).item_count;
            this.$dispatch('cart-count-updated', cartCount);
            this.loading = false;
        });
    },
    toggle () {
        this.show = !this.show;
        Grebify.noScroll(this.show);
    }
});